import React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";

export default function AddCommentIcon({ width = 20, height = 20 }) {
  const gradientId = "paint0_linear_comment_icon" + Math.random();
  const gradientUrl = "url(#" + gradientId + ")";

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M21.1662 5.33301H13.4473C13.7589 6.52775 13.7319 7.78564 13.3694 8.96594C13.0069 10.1462 12.3231 11.2024 11.3946 12.0162C10.4661 12.8301 9.32943 13.3696 8.1118 13.5743C6.89417 13.7789 5.6436 13.6408 4.5 13.1753V21.1659C4.4999 21.3243 4.54496 21.4795 4.62989 21.6132C4.71482 21.7469 4.8361 21.8537 4.97953 21.9209C5.12296 21.9882 5.28258 22.0132 5.4397 21.9929C5.59682 21.9727 5.74491 21.9081 5.86663 21.8067L10.6348 17.8327H21.1662C21.3872 17.8327 21.5992 17.7449 21.7555 17.5886C21.9117 17.4323 21.9995 17.2204 21.9995 16.9994V6.16632C21.9995 5.94531 21.9117 5.73336 21.7555 5.57708C21.5992 5.4208 21.3872 5.33301 21.1662 5.33301V5.33301Z"
        fill="#DADADA"
      />
      <Path
        d="M6.99987 2C6.01099 2 5.04432 2.29324 4.22209 2.84263C3.39987 3.39202 2.75902 4.1729 2.38059 5.0865C2.00217 6.00011 1.90315 7.00542 2.09607 7.9753C2.28899 8.94518 2.76519 9.83607 3.46443 10.5353C4.16367 11.2346 5.05457 11.7107 6.02445 11.9037C6.99433 12.0966 7.99963 11.9976 8.91324 11.6191C9.82685 11.2407 10.6077 10.5999 11.1571 9.77765C11.7065 8.95542 11.9997 7.98875 11.9997 6.99987C11.9997 5.67382 11.473 4.40209 10.5353 3.46443C9.59766 2.52677 8.32592 2 6.99987 2V2ZM9.49981 7.83318H7.83318V9.4998H6.16656V7.83318H4.49994V6.16656H6.16656V4.49993H7.83318V6.16656H9.49981V7.83318Z"
        fill={gradientUrl}
      />
      <Defs>
        <LinearGradient
          id={gradientId}
          x1="2"
          y1="4.16862"
          x2="6.81362"
          y2="14.0043"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#05858A" />
          <Stop offset="1" stopColor="#2AE8CB" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
